import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";
import { 
  DeactivateAdminMutationMutation, 
  DeactivateAdminMutationMutationVariables 
} from "../../../../../schemaTypes";
import { normalizeErrors } from "../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";

const deactivateAdminMutation = gql`
  mutation DeactivateAdminMutation($input: DeactivateAdminInput!) {
    deactivateAdmin(input: $input) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submit: (
        values: DeactivateAdminMutationMutationVariables
      ) => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      errors: NormalizedErrorMap | null;
      message: string | null;
    }
  ) => ReactElement | null;
}

export const DeactivateAdminController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, data }] = useMutation<
    DeactivateAdminMutationMutation,
    DeactivateAdminMutationMutationVariables
  >(deactivateAdminMutation);

  const errors = data?.deactivateAdmin?.errors
    ? normalizeErrors(data.deactivateAdmin.errors as any)
    : null;

  const submit = async (values: DeactivateAdminMutationMutationVariables) => {
    const response = await mutate({ variables: values });
    const deactivateAdmin = response?.data?.deactivateAdmin;
    if (deactivateAdmin?.errors) {
      return normalizeErrors(deactivateAdmin.errors as any);
    }
    
    return null;
  };

  const message = data?.deactivateAdmin?.message || null;

  return children({
    submit,
    loading,
    errors,
    message
  });
};
